module.exports = __webpack_public_path__ + "static/media/about.ce3a06f9.jpg";